const lazyImages = {
  el: {
    images: document.querySelectorAll<HTMLElement>('img[loading=lazy]'),
  },

  init(): void {
    this.el.images.forEach((lazyImage) => {
      const image = new Image()

      image.addEventListener('load', () => {
        lazyImage.setAttribute('data-loaded', 'true')
      })

      image.src = lazyImage.getAttribute('src') || ''
    })
  },
}

export default lazyImages
